const intervalChoiceUnits = [
  {
    id: 'd',
    nameSingular: 'day',
    namePlural: 'days',
    nameAmbiguous: 'day(s)',
    dayValue: 1,
  },
  {
    id: 'w',
    nameSingular: 'week',
    namePlural: 'weeks',
    nameAmbiguous: 'week(s)',
    dayValue: 7,
  },
  {
    id: 'm',
    nameSingular: 'month',
    namePlural: 'months',
    nameAmbiguous: 'month(s)',
    dayValue: 30,
  },
  {
    id: 'y',
    nameSingular: 'year',
    namePlural: 'years',
    nameAmbiguous: 'year(s)',
    dayValue: 365,
  },
]

export default intervalChoiceUnits



// WEBPACK FOOTER //
// ./src/views/misc/intervalChoiceUnits.js